// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./resourceChipSection.scss";
import CloseIcon from "../../../assets/close.svg";
// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const ResourceChipSection = (props) => {
  const {
    selectedProcedureList,
    handleSelectChip,
    handleRemoveChip,
  } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  // create UI ⇒

  const customChipUI = (procedure) => {
    return (
      <div
        className={
          "resource-chip-container " +
          // procedure?.id === selectedResourceProcedure?.id
          (procedure?.active ? "active-chip" : "")
        }
        onClick={() => handleSelectChip(procedure)}
      >
        <div className="resource-chip-title">{procedure?.procedure_name}</div>
        <div>
          <img
            src={CloseIcon}
            className="resource-chip-close-icon"
            alt=""
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChip(procedure);
            }}
          />
        </div>
      </div>
    );
  };

  const selectedTimeSlotUI = ({ start_time, end_time, status }) => {
    return (
      <div
        className={
          "resource-time-slot " +
          (status === "success"
            ? "slot-success"
            : status === "failure"
              ? "slot-failure"
              : "")
        }
      >{`${start_time} - ${end_time} `}</div>
    );
  };

  const selectedCustomSlot = ({ startTime, endTime }) => {
    return startTime && endTime ? (
      <div
        className={"resource-time-slot slot-success"}
      >{`${startTime} - ${endTime} `}</div>
    ) : null;
  };

  const resourceChipUI = () => {
    return (
      <div className="dashborad-appointments-filter-chips d-flex">
        {selectedProcedureList.map((procedure, index) => (
          <div
            style={{ border: "none" }}
            className="deletable-chip"
            key={index}
          >
            {customChipUI(procedure)}
            {procedure?.start_time &&
              procedure?.end_time &&
              !procedure.custom_slot &&
              selectedTimeSlotUI(procedure)}
            {procedure?.alloted_custom_slot?.startTime &&
              procedure?.alloted_custom_slot?.endTime &&
              procedure.custom_slot &&
              selectedCustomSlot(procedure["alloted_custom_slot"])}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="resource-multi-chip-container">{resourceChipUI()}</div>
  );
};

//export
export default ResourceChipSection;
